export const getAuthData = (data) => {
	const isAuthenticated = true;
	const {
		id,
		uuid,
		meta: {
			access_token: token
		},
		role
	} = data;

	const authData = { data: { ...data, role } };

	const authLocalStorage = {
		data: { role, token, user: { id: id, uuid } },
		isAuthenticated
	};

	return { authData, authLocalStorage };
};
